import React, { forwardRef, useContext } from 'react'
import { PostPurchaseContext, PostPurchaseDispatchContext } from '../context/PostPurchaseContext';

const FormDateInput = forwardRef(function FormDateInput(props, ref) {
    const state = useContext(PostPurchaseContext);
    const dispatch = useContext(PostPurchaseDispatchContext);
    const { name, errorMessage, label, extraClasses } = props;
    const inputErrorClasses = ["outline", "outline-2", "outline-[#FD6F64]"]
    const labelErrorClasses = ["after:content-[attr(data-error-msg)]", "before:content-[attr(data-error-icon)]"]
    
    function handleInputChange({ target }) {
        ref.current.classList.remove(...inputErrorClasses)
        ref.current.parentElement.classList.remove(...labelErrorClasses)
        ref.current.parentElement.classList.add("before:content-none")
        
        const currentDate = new Date().toISOString().slice(0, 10); // get current date in ISO format
        const selectedDate = target.value;
      
        if (selectedDate > currentDate) {
          // if selected date is in the future, set input value to empty string
          target.value = "";
          alert("You cannot select future dates.");
        }

        dispatch({
          type: "setCustomerData",
          payload: { name: [target.name], value: target.value },
        });
    }
    return (
        <label
            data-error-icon="!"
            data-error-msg={errorMessage}
            className={`flex-1 w-3/6  relative after:z-10 after:absolute after:text-[#FD6F64] after:text-[12px] after:font-semibold after:left-0 after:bottom-0 after:translate-y-full before:absolute before:right-2 before:top-1/2 before:bottom-1/2 before:w-[20px] before:h-[20px] before:rounded-full before:bg-[#FF7062] before:text-white before:content-none before:flex before:items-center before:justify-center ${extraClasses}`}
        >
            <div className="uppercase font-normal after:content-['*'] after:text-brio-200">
                {label}
            </div>
            <input
                type="date"
                ref={ref}
                name={name}
                value={state[name]}
                onChange={handleInputChange}
                className="text-muted-800 min-w-0 min-h-[4rem] w-full py-2 px-4 rounded-xl"
            />
        </label>
    )
})

export default FormDateInput